import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=007d235e&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007d235e')) {
      api.createRecord('007d235e', component.options)
    } else {
      api.reload('007d235e', component.options)
    }
    module.hot.accept("./Account.vue?vue&type=template&id=007d235e&", function () {
      api.rerender('007d235e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/auth/profile/components/Account.vue"
export default component.exports